import counterpart from 'counterpart';

export function proxyCounterpart (translationKey, options = null) {
  try {
    const translateOptions = options || { fallback: '' };

    return counterpart.translate(translationKey, translateOptions);
  } catch (e) {
    return '';
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/proxyCounterpart.js
 **/